import "./ReportFifthSection.css";

const PROB_COLOR = { High: "#e74c3c", Medium: "#f39c12", Low: "#27ae60" };
const IMPACT_COLOR = { High: "#e74c3c", Critical: "#7b0000", Medium: "#f39c12", Low: "#27ae60" };

const DEFAULT_MARKET = {
  tam: "India's digital and services startup ecosystem spans ₹1,50,000+ Cr across all sectors — representing the full opportunity horizon for your category at national scale.",
  sam: "Your serviceable market covers the addressable segment within your stated coverage area and business model — estimated at ₹3,000–15,000 Cr depending on market penetration and segment depth.",
  som: "A focused founding team with strong unit economics can realistically capture ₹50–300 Cr in Years 1–3 by executing a targeted GTM strategy with clear distribution channels.",
};

const DEFAULT_RISKS = [
  {
    risk: "Market Adoption Lag",
    probability: "Medium",
    impact: "High",
    mitigation: "Conduct 30+ structured customer discovery interviews before committing MVP scope. Use jobs-to-be-done framework to validate the pain intensity.",
  },
  {
    risk: "Competitive Disruption",
    probability: "High",
    impact: "High",
    mitigation: "Invest early in building a defensible moat — proprietary data, network effects, or IP. Map the 3 closest competitors and document differentiation gaps weekly.",
  },
  {
    risk: "Financial Runway Pressure",
    probability: "Medium",
    impact: "High",
    mitigation: "Maintain an 18-month runway target at all times. Explore Startup India grants, DST-NIDHI schemes, and SIDBI ARISE funding before approaching VCs.",
  },
  {
    risk: "Regulatory & Compliance Gap",
    probability: "Low",
    impact: "High",
    mitigation: "Engage a domain-specific legal advisor before acquiring first paying customers. Check sector-specific compliance (DPDP Act, RBI norms, FSSAI, etc.) upfront.",
  },
];

export default function ReportFifthSection({ res }) {
  const aiReport =
    res?.sectionScores?.aiReport ??
    res?.sectionScores?.ai_report ??
    res?.aiReport ??
    {};

  const market = aiReport.marketSizing ?? DEFAULT_MARKET;
  const risks =
    Array.isArray(aiReport.riskMatrix) && aiReport.riskMatrix.length > 0
      ? aiReport.riskMatrix
      : DEFAULT_RISKS;

  const marketCards = [
    { label: "TAM", sublabel: "Total Addressable Market", text: market.tam, accent: "#0077d6" },
    { label: "SAM", sublabel: "Serviceable Available Market", text: market.sam, accent: "#7c3aed" },
    { label: "SOM", sublabel: "Serviceable Obtainable Market", text: market.som, accent: "#059669" },
  ];

  return (
    <div className="r5-section">
      <div className="r5-header">
        <span className="r5-header-title">MARKET ANALYSIS &amp; RISK ASSESSMENT</span>
        <span className="r5-header-brand">MarsMate AI</span>
      </div>

      <div className="r5-body">
        {/* ── Market Sizing ──────────────────────────────── */}
        <div className="r5-block">
          <h3 className="r5-block-title">
            <span className="r5-block-icon">📊</span> Market Sizing
          </h3>
          <div className="r5-market-grid">
            {marketCards.map(({ label, sublabel, text, accent }) => (
              <div
                className="r5-market-card"
                key={label}
                style={{ borderTopColor: accent }}
              >
                <div className="r5-market-badge" style={{ color: accent }}>
                  {label}
                </div>
                <div className="r5-market-sublabel">{sublabel}</div>
                <p className="r5-market-text">{text}</p>
              </div>
            ))}
          </div>
        </div>

        {/* ── Risk Matrix ─────────────────────────────────── */}
        <div className="r5-block">
          <h3 className="r5-block-title">
            <span className="r5-block-icon">⚠️</span> Risk Matrix
          </h3>
          <div className="r5-risk-table-wrap">
            <table className="r5-risk-table">
              <thead>
                <tr>
                  <th className="r5-th-risk">Risk</th>
                  <th className="r5-th-badge">Probability</th>
                  <th className="r5-th-badge">Impact</th>
                  <th className="r5-th-mit">Mitigation Strategy</th>
                </tr>
              </thead>
              <tbody>
                {risks.map((row, i) => (
                  <tr key={i}>
                    <td className="r5-risk-name">{row.risk}</td>
                    <td className="r5-td-center">
                      <span
                        className="r5-badge"
                        style={{ backgroundColor: PROB_COLOR[row.probability] ?? "#888" }}
                      >
                        {row.probability}
                      </span>
                    </td>
                    <td className="r5-td-center">
                      <span
                        className="r5-badge"
                        style={{ backgroundColor: IMPACT_COLOR[row.impact] ?? "#888" }}
                      >
                        {row.impact}
                      </span>
                    </td>
                    <td className="r5-risk-mitigation">{row.mitigation}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
